import React from 'react';
import GeneratorLabel from '../../../GeneratorLabel';
import { MyInput } from '../../../../../../../Base/Form';
import { useStore } from '../../../../../../../../store/rootStore';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import s from '../RichParams.module.scss';
const FooterSection = ({ handleSetFooter, blockField }) => {
    const { templateMessagesStore: { richTemplateFooter }, } = useStore();
    const { t } = useTranslation();
    return (React.createElement("div", { className: s.templateAddFooter },
        React.createElement(GeneratorLabel, { textKey: "footer" }),
        React.createElement(MyInput, { value: richTemplateFooter || '', onChangeHandler: (value) => {
                if (value.length <= 60) {
                    handleSetFooter(value);
                }
            }, placeholder: t('footerText'), size: "large", disabled: blockField() })));
};
export default observer(FooterSection);
